import { useEffect } from 'react';
import { GamePhase, GameState } from '../types';
import {
  saveUserData,
  updateUserGroschen,
  updateUserOwnedDice,
  updateUserDiceConfigs,
} from '../services/LocalStorageService';

/**
 * 处理游戏数据的自动持久化
 * 监听 gameState 变化，自动保存到 localStorage
 */
export const useGamePersistence = (gameState: GameState) => {
  // 在格罗申数量变化时保存到本地存储
  const groschen = gameState.players[0].groschen;
  const ownedDice = gameState.players[0].ownedDice;
  const { phase, diceConfigs } = gameState;

  useEffect(() => {
    if (phase !== GamePhase.START) {
      updateUserGroschen(groschen);
    }
  }, [groschen, phase]);

  // 在拥有的骰子变化时保存到本地存储
  useEffect(() => {
    if (phase !== GamePhase.START) {
      updateUserOwnedDice(ownedDice);
    }
  }, [ownedDice, phase]);

  // 在骰子配置变化时保存到本地存储
  useEffect(() => {
    if (phase !== GamePhase.START) {
      updateUserDiceConfigs(diceConfigs);
    }
  }, [diceConfigs, phase]);

  // 在游戏结束时保存完整的用户数据
  useEffect(() => {
    if (gameState.phase === GamePhase.GAME_OVER) {
      saveUserData(
        gameState.players[0],
        gameState.diceConfigs,
        gameState.settings
      );
    }
  }, [gameState.phase, gameState.players, gameState.diceConfigs, gameState.settings]);
};
